import React from 'react';
import { useEditorStore, useExportStore } from '@/stores';
import { useAutoSave } from '@/hooks';
import { HistoryIndicator } from '@/components/ui/HistoryIndicator';
import { SaveMenu } from '@/components/ui/SaveMenu';
import { SaveIndicator } from '@/components/ui/SaveIndicator';

export function Header() {
  const { status, lastSaved, error, save } = useAutoSave({ debounceMs: 2000 });

  return (
    <header className="flex items-center justify-between px-6 py-4 border-b border-white/5 bg-navy-dark/50">
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 rounded-xl overflow-hidden">
          <img
            src="/images/mooncloak_logo_512.png"
            alt="mooncloak"
            className="w-full h-full object-cover"
          />
        </div>
        <div>
          <h1 className="text-xl font-bold tracking-tight">
            <span className="font-brand font-normal">mooncloak</span>
            <span className="text-fg-muted"> · </span>
            ad studio
          </h1>
          <p className="text-xs text-fg-subtle mt-0.5">
            Design ads that adapt to every channel
          </p>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <SaveIndicator status={status} lastSaved={lastSaved} error={error} onSave={save} />
        <div className="w-px h-6 bg-white/10" />
        <SaveMenu />
        <HistoryIndicator />
        <ExportAllButton />
      </div>
    </header>
  );
}

function ExportAllButton() {
  const isExporting = useExportStore((s) => s.isExporting);
  const setActivePanel = useEditorStore((s) => s.setActivePanel);

  return (
    <button
      onClick={() => setActivePanel('export')}
      disabled={isExporting}
      className="btn-accent flex items-center gap-2 disabled:opacity-50"
    >
      {isExporting ? (
        <>
          <LoadingSpinner />
          Exporting...
        </>
      ) : (
        <>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Export
        </>
      )}
    </button>
  );
}

function LoadingSpinner() {
  return (
    <svg
      className="animate-spin w-4 h-4"
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
